import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Link } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { Features } from 'generated/featureDefinitions'

import Callout from 'modules/core/components/Callout'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import MissingClockInInconsistency from 'modules/attendance/components/ClockIn/Modals/MissingClockInInconsistency'
import { useAttendanceFeatures } from 'modules/attendance/lib/attendanceFeaturesContext'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import BodyHeader from './BodyHeader'

interface Props {
  isDaily: boolean
  showHourBalance: boolean
}

const Layout = ({ children, isDaily, showHourBalance }: React.PropsWithChildren<Props>) => {
  const { featureAvailability: hasInconsistencies } = useAttendanceFeatures(
    Features.time_tracking_time_alerts
  )
  const hasBankOfHours = hasFeature('dev_time_tracking_bank_of_hours')

  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const [calloutDismissed, setCalloutDismissed] = useLocalStorage<boolean>(
    LOCAL_STORAGE_KEYS.hideBankOfHoursCallout,
    false
  )
  const discoveryArticle = navigation.discover.productUpdates.item.fullPath({
    slug: 'bank-of-hours',
  })

  const calloutVisible = !calloutDismissed && hasBankOfHours && !isDaily

  return (
    <ResponsivePage.Body showHeader={false}>
      {calloutVisible && (
        <Box paddingBottom="s24" width="full">
          <Callout
            type="info"
            title={i18n.t('clock_in.header.bank_of_hours_callout.title')}
            description={i18n.t('clock_in.header.bank_of_hours_callout.description')}
            onRemove={() => setCalloutDismissed(true)}
            action={
              <>
                <Link.Touchable type="solid" onClick={() => navigate(discoveryArticle)} expand>
                  {i18n.t('clock_in.header.bank_of_hours_callout.learn_more')}
                </Link.Touchable>
              </>
            }
          />
        </Box>
      )}

      <BodyHeader isDaily={isDaily} showHourBalance={showHourBalance} />

      <Box extra={{ 'data-intercom-target': 'clock-in-page' }}>
        {hasInconsistencies && <MissingClockInInconsistency isClockInPage />}
        {children}
      </Box>
    </ResponsivePage.Body>
  )
}

export default Layout
